export const DetailsToShowKeysIntl: Record<string, (string | undefined)[]> = {
    shipmentDetailsKeys: [
        'service_type',
        'booking_service_type_id',
        'load_type',
        'movement_type',
        'forward_reference_number',
        'courier_partner_reference_number',
        'ecom_shipment',
        'price_details',
        'sales_order_number',
        'purchase_order_number',
        'delivery_time_slot_start',
        'delivery_time_slot_end',
        'expected_delivery_date',
    ],
    taxAndCustomDetailsKeys: [
        'is_risk_surcharge_applicable',
        'against_bond_lut',
        'meis',
        'freight_cost',
        'consignor_iec_number',
        'igst',
        'sgst',
        'cgst',
        'tax_details_receiver_gstin',
        'tax_details_sender_gstin',
        'total_tax',
        'tax_percentage',
        'export_reference_number',
        'import_reference_number',
        'international_detail_shipment_purpose',
        'export_invoice_date',
        'invoice_number',
        'fob_value',
        'invoice_date',
        'nefi_flag',
        'invoice_type',
        'delivery_terms',
        'inco_terms',
    ],
    dangerousGoodKeys: [
        'is_dangerous_good',
        'dangerous_good_accessible',
        'dangerous_good_un_number',
        'dangerous_good_name',
        'dangerous_good_class',
        'dangerous_good_division',
        'dangerous_good_category',
        'dangerous_good_packing_group',
        'dangerous_good_category_type',
        'dangerous_good_category_packing_instruction',
    ],
    codDetailsKeys: [
        'cod_favor_of',
        'cod_amount',
        'cod_mode',
        'payment_collection_mode_list',
    ],
    packageDetailsKeys: [
        'weight',
        'num_pieces',
        'description',
        'length',
        'width',
        'declared_value',
        'height',
        'is_battery',
        'given_weight',
        'given_length',
        'given_height',
        'product_code',
        'given_width',
        'document_list',
        'is_stackable',
        'currency_code',
    ],
    billingDetailsKeys: [
        'billing_address_line_1',
        'billing_address_line_2',
        'billing_address_line_3',
        'billing_address_line_4',
        'billing_address_line_5',
        'billing_city',
        'billing_state',
        'billing_country',
    ],
    consigneeDetails: [
        'destination_name',
        'destination_type',
        'destination_address_line_1',
        'destination_address_line_2',
        'destination_address_line_3',
        'destination_address_line_4',
        'destination_address_line_5',
        'destination_city',
        'destination_state',
        'destination_pincode',
        'destination_country',
        'destination_phone',
        'receiver_vat_number',
        'destination_service_time_mins',
    ],
    consignorDetails: [
        'sender_name',
        'consignor_tax_id',
        'consignor_company_name',
        'consignor_pan',
        'sender_phone',
        'consignor_kyc_doc_type',
        'consignor_gstin_number',
        'consignor_kyc_doc_number',
        'total_gst_paid_amount',
        'consignor_kyc_front_image',
        'total_gst_paid_currency',
        'consignor_kyc_back_image',
        'origin_type',
        undefined,
        'sender_address_line_1',
        undefined,
        'sender_address_line_2',
        undefined,
        'sender_address_line_3',
        undefined,
        'sender_address_line_4',
        undefined,
        'sender_address_line_5',
        undefined,
        'sender_country',
        undefined,
        'sender_state',
        undefined,
        'sender_city',
        undefined,
        'sender_pincode',
        undefined,
        'sender_bank_account_number', //
        undefined,
        'sender_bank_ad_code', //
        undefined,
        'sender_bank_ifsc_code', //
        undefined,
        'sender_service_time_mins',
    ],
    itemDetails: [
        'item_value',
        'piece_number',
        'item_description',
        'sku_number',
        'gst_value',
        'hsn_code',
        'gst_percentage',
        'duty_value',
        'cess_value',
        'product_dead_weight',
        'ate_number',
        'product_type',
        'composition',
        'product_url',
        'product_height',
        'rodtep_scheme',
        'product_length',
        'origin_of_goods',
        'product_width',
    ],
    pieceDetails: [
        'description',
        'reference_number',
        'declared_value',
        'number_of_items',
        'length',
        'number_pieces',
        'width',
        'piece_number',
        'height',
        'status',
        'weight',
        'volumetric_weight',
        'is_dangerous_good',
        'dangerous_good_accessible',
        'dangerous_good_un_number',
        'dangerous_good_name',
        'dangerous_good_class',
        'dangerous_good_division',
        'dangerous_good_category',
        'dangerous_good_packing_group',
        'dangerous_good_category_type',
        'dangerous_good_category_packing_instruction',
        'purchase_order_number',
        'piece_product_code',
        'manufacturing_country',
        'is_kit',
        'eccn',
        'hsn_code',
        'igst',
        'sgst',
        'cgst',
        'tax_details_receiver_gstin',
        'tax_details_sender_gstin',
        'total_tax',
        'tax_percentage',
        'forward_reference_number',
        'payment_collection_mode_list',
        'item_unit',
    ],
};

export const DetailsToShowKeysDomestic: Record<string, (string | undefined)[]> = {
    shipmentDetailsKeys: [
        'load_type',
        'service_type',
        'movement_type',
        'forward_reference_number',
        'courier_partner',
        'courier_partner_reference_number',
        'transport_mode',
        'price_details',
        'sales_order_number',
        'purchase_order_number',
        'delivery_time_slot_start',
        'delivery_time_slot_end',
        'expected_delivery_date',
    ],
    taxAndCustomDetailsKeys: [
        'is_risk_surcharge_applicable',
        'igst',
        'sgst',
        'cgst',
        'tax_details_receiver_gstin',
        'tax_details_sender_gstin',
        'total_tax',
        'tax_percentage',
    ],
    dangerousGoodKeys: [
        'is_dangerous_good',
        'dangerous_good_accessible',
        'dangerous_good_un_number',
        'dangerous_good_name',
        'dangerous_good_class',
        'dangerous_good_division',
        'dangerous_good_category',
        'dangerous_good_packing_group',
        'dangerous_good_category_type',
        'dangerous_good_category_packing_instruction',
    ],
    codDetailsKeys: [
        'cod_favor_of',
        'cod_amount',
        'cod_mode',
        'payment_collection_mode_list',
    ],
    packageDetailsKeys: [
        'weight',
        'num_pieces',
        'description',
        'length',
        'width',
        'declared_value',
        'height',
        'given_weight',
        'given_length',
        'given_height',
        'product_code',
        'given_width',
        'document_list',
        'is_stackable',
        'currency_code',
    ],
    consigneeDetails: [
        'destination_name',
        'destination_address_line_1',
        'destination_address_line_2',
        'destination_address_line_3',
        'destination_address_line_4',
        'destination_address_line_5',
        'destination_city',
        'destination_state',
        'destination_pincode',
        'destination_country',
        'destination_phone',
        'destination_service_time_mins',
    ],
    consignorDetails: [
        'sender_name',
        'sender_phone',
        'sender_address_line_1',
        'sender_address_line_2',
        'sender_address_line_3',
        'sender_address_line_4',
        'sender_address_line_5',
        'sender_country',
        'sender_state',
        'sender_city',
        'sender_pincode',
        'sender_service_time_mins',
    ],
    pieceDetails: [
        'description',
        'reference_number',
        'declared_value',
        'quantity',
        'length',
        'number_pieces',
        'width',
        'piece_number',
        'height',
        'status',
        'weight',
        'volumetric_weight',
        'is_dangerous_good',
        'dangerous_good_accessible',
        'dangerous_good_un_number',
        'dangerous_good_name',
        'dangerous_good_class',
        'dangerous_good_division',
        'dangerous_good_category',
        'dangerous_good_packing_group',
        'dangerous_good_category_type',
        'dangerous_good_category_packing_instruction',
        'purchase_order_number',
        'piece_product_code',
        'manufacturing_country',
        'is_kit',
        'eccn',
        'hsn_code',
        'igst',
        'sgst',
        'cgst',
        'tax_details_receiver_gstin',
        'tax_details_sender_gstin',
        'total_tax',
        'tax_percentage',
        'forward_reference_number',
        'payment_collection_mode_list',
        'item_unit',
    ],
    itemDetails: [
        'item_value',
        'piece_number',
        'item_description',
        'sku_number',
        'gst_value',
        'hsn_code',
        'gst_percentage',
        'duty_value',
        'cess_value',
        'product_dead_weight',
        'ate_number',
        'product_type',
        'composition',
        'product_url',
        'product_height',
        'rodtep_scheme',
        'product_length',
        'origin_of_goods',
        'product_width',
    ],
};
